import { configureStore, ThunkAction, Action, combineReducers } from '@reduxjs/toolkit';
import GlobalReducer from './Reducers/GlobalSlice';
import MemberReducer from './Reducers/MemberDetailsSlice';
import SearchReducer from './Reducers/SearchSlice';
import FinancialInfo from './Reducers/FinancialInfoSlice';
import MyLoadsReducer from './Reducers/MyLoadsSlice';
import ContentOrConfigReducer from './Reducers/ContentOrConfigSlice';
import NatNalReducer from './Reducers/NatNalSlice';
import LoadReducer from './Reducers/LoadSlice';
import PreferencesReducer from './Reducers/PreferencesSlice';

const rootReducer = combineReducers({
  global: GlobalReducer,
  member: MemberReducer,
  search: SearchReducer,
  financialInfo: FinancialInfo,
  myLoads: MyLoadsReducer,
  ContentOrConfig: ContentOrConfigReducer,
  NatNal: NatNalReducer,
  Load: LoadReducer,
  Preferences: PreferencesReducer,
});
export function setupStore(preloadedState?: Partial<RootState>) {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }),
    preloadedState,
  });
}

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
